module.exports = __webpack_public_path__ + "img/merchant-car-imgbg.6fd5333a.png";